import CheckupDigitalOmint from "@/pages/checkup-digital-omint/index.vue";
import CheckupDigitalOmintList from "@/pages/checkup-digital-omint/list.vue";
import CheckupDigitalOmintHome from "@/pages/checkup-digital-omint/home.vue";
import CheckupDigitalOmintHowWorks from "@/pages/checkup-digital-omint/how_it_works.vue";
import BoaHora from "@/pages/checkup-digital-omint/boa-hora.vue";
import BoaHoraHow from "@/pages/checkup-digital-omint/boa-hora-how.vue";
import BoaHoraStatus from "@/pages/checkup-digital-omint/boa-hora-status.vue";
import BoaHoraSchedule from "@/pages/checkup-digital-omint/boa-hora-schedule.vue";
import BoaHoraConsulta from "@/pages/checkup-digital-omint/boa-hora-consulta.vue";
import store from "@/store";
import { canSeeCheckupDigitalOmint } from "@/utils/checkupDigitalOmint";

const ensureAllowedVinculo = (_to, _from, next) => {
  if (!canSeeCheckupDigitalOmint(store.state.saude.vinculo)) {
    next({ path: "/" });
    return;
  }
  next();
};

const guarded = (extra = {}) => ({
  beforeEnter: ensureAllowedVinculo,
  meta: {
    checkPathDisabled: true,
    ...extra
  }
});

const routes: Route[] = [
  {
    path: "/programa-saude-2",
    component: CheckupDigitalOmint,
    children: [
      {
        path: "",
        name: "programa_saude_2.lista",
        component: CheckupDigitalOmintList,
        ...guarded({
          backTo: "/",
          registerAccess: {
            servico: "Check-up Digital Omint",
            funcionalidade: "Acesso ao Check-up Digital Omint"
          }
        })
      },
      {
        path: "avaliacao",
        name: "programa_saude_2.avaliacao",
        component: CheckupDigitalOmintHome,
        ...guarded({
          backTo: "/programa-saude-2"
        })
      },
      {
        path: "avaliacao/como-funciona",
        name: "programa_saude_2.como_funciona",
        component: CheckupDigitalOmintHowWorks,
        ...guarded({
          backTo: "/programa-saude-2/avaliacao"
        })
      },
      {
        path: "como-funciona",
        redirect: "/programa-saude-2/avaliacao/como-funciona"
      },
      {
        path: "boa-hora",
        name: "programa_saude_2.boa_hora",
        component: BoaHora,
        ...guarded({
          backTo: "/programa-saude-2"
        })
      },
      {
        path: "boa-hora/como-funciona",
        name: "programa_saude_2.boa_hora.como_funciona",
        component: BoaHoraHow,
        ...guarded({
          backTo: "/programa-saude-2/boa-hora"
        })
      },
      {
        path: "boa-hora/acompanhamento",
        name: "programa_saude_2.boa_hora.acompanhamento",
        component: BoaHoraStatus,
        ...guarded({
          backTo: "/programa-saude-2"
        })
      },
      {
        path: "boa-hora/agendamento",
        name: "programa_saude_2.boa_hora.agendamento",
        component: BoaHoraSchedule,
        ...guarded({
          backTo: "/programa-saude-2/boa-hora/acompanhamento"
        })
      },
      {
        path: "boa-hora/consulta",
        name: "programa_saude_2.boa_hora.consulta",
        component: BoaHoraConsulta,
        ...guarded({
          backTo: "/programa-saude-2/boa-hora/acompanhamento"
        })
      }
    ]
  }
];

export default routes;
